module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-impressed.37a5a34c.png";